import { NavigateOptions, To, useLocation, useNavigate } from 'react-router-dom'

export const useNavigator = () => {
  const baseNavigate = useNavigate()
  const location = useLocation()
  const navigate = (to: To, options?: NavigateOptions) => {
    // You can add custom logic here if needed
    return baseNavigate(to, { ...options, state: { from: location.pathname, ...options?.state } })
  }

  const back = (path?: string) => {
    // Check the history length to decide whether to go back or navigate to a specific path
    if (!path) baseNavigate(-1)
    else {
      const state = location.state as { from?: string }
      if (state?.from && state.from === path) baseNavigate(-1)
      else baseNavigate(path, { replace: true })
    }
  }

  /**
   * Smart navigation that handles Cmd/Ctrl+Click to open in new tab
   * @param to - The path to navigate to
   * @param event - Optional mouse event (if provided and Cmd/Ctrl is pressed, opens in new tab)
   * @param options - Navigation options
   */
  const navigateWithEvent = (to: To, event?: React.MouseEvent, options?: NavigateOptions) => {
    if (event?.metaKey || event?.ctrlKey) {
      // Cmd/Ctrl+Click: Open in new tab
      const url = typeof to === 'string' ? to : to.pathname || '/'
      window.open(url, '_blank')
    } else {
      // Normal click: Navigate in same tab
      navigate(to, options)
    }
  }

  return { navigate, back, navigateWithEvent }
}
